import React from 'react';
import { connect } from 'react-redux';
import { getDateMDYY } from '_helpers';
import styles from './Common.module.css';
import { PatientCareCenterAlTherAct } from './TherAct';
import { PatientCareCenterAlTherEx } from './TherEx';
import { PatientCareCenterAlSelfCare } from './SelfCare';
import { PatientCareCenterAlNeuro } from './Neuro';
import { PatientCareCenterAlManual } from './Manual';
import { PatientCareCenterAlGait } from './Gait';
import { PatientCareCenterAlAqua } from './Aqua';
import { PatientCareCenterAlMod } from './Mod';
import { PatientCareCenterAlOther } from './Other';
import { PatientCareCenterAlWorkHard } from './WorkHard';
import { PatientCareCenterAlPhysRecond } from './PhysRecond';
import { PatientCareCenterAlSpeech } from './Speech';
class PatientCareCenterAlBody extends React.Component {

    render() {
        return (
            <div className={this.props.mcWrapper ? styles.body_wrapper_message_center : styles.body_wrapper}>
                <div className={styles.body}>

                    <div className={styles.row}>
                        <span className={styles.col1_bold_italic} />
                        {Object.keys(this.props.MLEXLOG)
                            .map(x => {
                                const exlog = this.props.MLEXLOG[x];
                                return (
                                    <span key={exlog.XLNO} className={styles.col_bold_italic}>
                                        {getDateMDYY(exlog.TRTDATE)}

                                        {exlog.XLNO < 0 &&
                                            <>&nbsp; (RTM)</>
                                        }
                                    </span>
                                )
                            })
                        }
                    </div>
                    <div className={styles.row}>
                        <span className={styles.col1_bold_italic}>
                            {'Visit #'}
                        </span>
                        {Object.keys(this.props.MLEXLOG)
                            .map(x => {
                                const exlog = this.props.MLEXLOG[x];
                                return (
                                    <span key={exlog.XLNO} className={styles.col_bold_italic}>
                                        {exlog.VISITNUM}
                                    </span>
                                )
                            })
                        }
                    </div>
                </div>

                <PatientCareCenterAlTherEx epno={this.props.epno} />
                <PatientCareCenterAlTherAct epno={this.props.epno} />
                <PatientCareCenterAlSelfCare epno={this.props.epno} />
                <PatientCareCenterAlNeuro epno={this.props.epno} />
                <PatientCareCenterAlManual epno={this.props.epno} />
                <PatientCareCenterAlGait epno={this.props.epno} />
                <PatientCareCenterAlAqua epno={this.props.epno} />
                <PatientCareCenterAlSpeech epno={this.props.epno} />
                <PatientCareCenterAlMod epno={this.props.epno} />
                <PatientCareCenterAlOther epno={this.props.epno} />
                <PatientCareCenterAlWorkHard epno={this.props.epno} />
                <PatientCareCenterAlPhysRecond epno={this.props.epno} />

            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    let displayMode = state.ui.al[ownprops.epno].displayMode;
    let MLEXLOG = Object.keys(state.entities.al.MLEXLOG)
        .filter(x => state.entities.al.MLEXLOG[x].EPNO === ownprops.epno)
        .sort((a, b) => new Date(state.entities.al.MLEXLOG[a].TRTDATE).getTime() - new Date(state.entities.al.MLEXLOG[b].TRTDATE).getTime())
        .map(x => state.entities.al.MLEXLOG[x]);

    MLEXLOG = displayMode === -1 || MLEXLOG.length <= displayMode ? MLEXLOG : MLEXLOG.slice(MLEXLOG.length - displayMode, MLEXLOG.length);

    return {
        MLEXLOG
    };
}

const connectedPatientCareCenterAlBody = connect(mapStateToProps)(PatientCareCenterAlBody);
export { connectedPatientCareCenterAlBody as PatientCareCenterAlBody };

